import {addItemsToByIdState} from '../reducer-utils';
import type {CollectionModel} from './collections-types';
import type {CollectionAction} from './collections-actions';
import {ActionTypes} from './collections-actions';

export type CollectionState<T extends CollectionModel> = {
    isLoading: boolean;
    byId: {
        [collectionModelId: string]: T;
    };
    errorMessage: string | null | undefined;
};

const collectionDefaultState = {
    isLoading: false,
    byId: {},
    errorMessage: null,
} as const;

export function createGenericCollectionReducerForType(collectionName: string) {
    return function collectionReducer(
        state: CollectionState<any> | null | undefined = collectionDefaultState,
        action: CollectionAction
    ): CollectionState<any> {
        if (!action.meta || collectionName !== action.meta.collectionType) {
            // @ts-ignore
            return state;
        }

        switch (action.type) {
            case ActionTypes.COLLECTIONS_FETCH_BY_ID_REQUEST:
            case ActionTypes.COLLECTION_REQUESTED: {
                // @ts-ignore
                return {...state, isLoading: true, errorMessage: null};
            }
            case ActionTypes.COLLECTIONS_FETCH_BY_ID_SUCCESS: {
                const response = action.payload;
                const {collectionType} = action.meta;
                // @ts-ignore
                const newCollections = addItemsToByIdState(response[collectionType], state.byId);

                // @ts-ignore
                return {
                    ...state,
                    byId: newCollections,
                    isLoading: false,
                };
            }
            case ActionTypes.COLLECTION_UPDATED: {
                const response = action.payload;
                const {collectionType} = action.meta;
                // @ts-ignore
                const newCollections = addItemsToByIdState(response[collectionType], {});

                // @ts-ignore
                return {
                    ...state,
                    byId: newCollections,
                    isLoading: false,
                };
            }
            case ActionTypes.COLLECTIONS_FETCH_BY_ID_FAILURE:
            case ActionTypes.COLLECTION_FAILED: {
                // TODO: do a better job of getting the error from the response
                // (action.payload)
                // @ts-ignore
                return {
                    ...state,
                    errorMessage: 'Something went wrong.',
                    isLoading: false,
                };
            }
            default:
                // @ts-ignore
                return state;
        }
    };
}
